import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

const ItemsPage = lazy(() =>
  import('../../pages/items/ItemsPage').then((m) => ({
    default: m.ItemsPage,
  })),
);

// Filter params may arrive in two formats: nuqs writes them as plain strings (e.g.
// `?incomplete=1`, `?org=a,b`) while TanStack Router's default search parser
// JSON-decodes scalars (so `1` becomes `number`). Accept both shapes here and let
// `pickFilterSearch` (and `useAssetFilters` via nuqs) normalise downstream.
const itemsSearchSchema = z.object({
  groupId: z.string().optional(),
  org: z.union([z.array(z.string()), z.string()]).optional(),
  brand: z.union([z.array(z.string()), z.string()]).optional(),
  category: z.union([z.array(z.string()), z.string()]).optional(),
  location: z.union([z.array(z.string()), z.string()]).optional(),
  incomplete: z.union([z.literal('1'), z.literal(1)]).optional(),
  missingAttribute: z.string().optional(),
  sort: z.string().optional(),
  page: z.union([z.number().int(), z.string()]).optional(),
});

export const Route = createFileRoute('/items/')({
  validateSearch: itemsSearchSchema,
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <ItemsPage />
    </Suspense>
  ),
});
